import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { StorageService } from 'src/app/shared/services/storage.service';
@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  public updatedAuthData;
  constructor(
    private router: Router,
    private auth: AuthenticationService,private storageService:StorageService) { }
  authService;
  refreshTokenInProgress = false;
  tokenRefreshedSource = new Subject();
  tokenRefreshed$ = this.tokenRefreshedSource.asObservable();
  refreshToken(): Observable<any> {
    if (this.refreshTokenInProgress) {
      return new Observable(observer => {
        this.tokenRefreshed$.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;
      let requestPayload = {
        refreshToken: JSON.parse(localStorage.getItem("refresh_token"))
      };
      let headers = {
        'Accept-Language': 'EN'
      }
      return this.auth.getRefreshToken(requestPayload, headers).pipe(
        tap((res) => {
          this.updatedAuthData = res;
          this.refreshTokenInProgress = false;
          this.tokenRefreshedSource.next();
        }));
    }
  }
  handleResponseError(error, request?, next?) {
    if (error.status === 400) {
      if (error.error.response[0] == 'Invalid Refresh token or token expired, Please login again using username and password.'
       || error.error.response[0] == 'Refresh token should not be empty.'
       || error.error.response[0] == 'Your session has been expired. Please login again.'
       || error.error.response[0] == `You have been logged out because your account is active on another device.\nPlease login again using username and password.`
       ) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('token_type');
        sessionStorage.setItem('logOut',JSON.stringify(true));
        this.router.navigate(['/ordering']);//redirection to login on session expired and api status code : 400.
      }
    }
    if (error.status === 401 && error.error.response[0] == 'Your session has been expired. Please login again.') {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('token_type');
      sessionStorage.setItem('logOut',JSON.stringify(true));
      this.router.navigate(['/ordering']); //redirection to login on session expired and api status code : 401.
    }
    if (error.status === 401 && error.error.response[0] == 'Authentication Failed') {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('token_type');
      sessionStorage.setItem('logOut',JSON.stringify(true));
    }
    if (error.status === 401 && error.error.response[0] != 'Your session has been expired. Please login again.') {
       return this.refreshToken().pipe(
        switchMap((res) => {
          this.storageService.setAccessToken(res.response.access_token)
          let auth_token = res.response.access_token;
          let token_type = res.response.token_type;
          request = request.clone({
            setHeaders: {
              'Authorization': token_type + ' ' + auth_token,
              'Content-Type': 'application/json'
            }
          });
          return next.handle(request);
        }),
        catchError(e => {
          if (e.status !== 401) {
            return this.handleResponseError(e);
          } else {
          }
        }));
    }
    return throwError(error);
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (this.updatedAuthData && this.updatedAuthData.access_token) {
      request = request.clone({
        setHeaders: {
          'Authorization': this.updatedAuthData.token_type + ' ' + this.updatedAuthData.access_token,
          'Content-Type': 'application/json'
        }
      });
    }
    return next.handle(request).pipe(catchError(error => {
      return this.handleResponseError(error, request, next);
    }));
  }
}
